import { message } from '@/App'
import axios from 'axios'
import { globalState, globalActions } from '@/store'

const agentRequest = axios.create({
  baseURL: '/ai-agent/api/core/app/platform',
  timeout: 12000,
  headers: {},
})

agentRequest.interceptors.request.use(
  config => {
    const { userInfo } = globalState
    config.headers = Object.assign({}, config.headers, {
      Authorization: userInfo.agent_token,
      token: userInfo.agent_token,
    })
    return config
  },
  error => {
    console.log('request error =>', error)
    return Promise.reject(error)
  },
)

// 添加响应拦截器
agentRequest.interceptors.response.use(
  response => {
    if (response.request.responseType === 'arraybuffer') {
      return Promise.resolve(response.data)
    }
    // 400 账号被封禁 401: 登录过期 402:禁言 403:ip 封禁
    if (
      [401, 403, 400].includes(response.data?.code) ||
      response.data?.message === '登录过期'
    ) {
      // globalActions.logout()
      return Promise.reject(response.data)
    } else if (response.data?.code !== 200) {
      const errMessage = response?.data?.message || '请求失败'
      message.open({
        key: 'api',
        type: 'error',
        content: errMessage,
      })
      return Promise.reject(errMessage)
    }

    return Promise.resolve(response.data)
  },
  error => {
    console.log('response error =>', error)
    let errMessage =
      error.response?.data?.message || error.message || '请求失败'

    if (error.response?.status === 401 || error.response?.data?.code === 401) {
      // globalActions.logout()
      return
    }

    if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
      errMessage = '网络错误, 请稍后重试'
      if (error.config.url.includes('/query_recommend')) {
        return
      }
    }

    if (
      error.code === 'ECONNABORTED' ||
      (error.message && /timeout/.test(error.message))
    ) {
      errMessage = '网络超时, 请稍后重试'
    }

    if (!navigator.onLine) {
      errMessage = '您当前处于离线状态，请检查网络连接'
    }

    message.open({
      key: 'api',
      type: 'error',
      content: errMessage,
    })

    return Promise.reject(error)
  },
)

export { agentRequest }
